module.exports = __webpack_public_path__ + "static/media/messages-ephemeres.5fcee922.png";